import { ReportData } from '../preview/types';
import { statusConfig } from './constants';
import ReportGridItem from './ReportGridItem';
import ReportTableItem from './ReportTableItem';

interface ReportListItemProps {
    report: ReportData;
    onDelete: (id: ReportData['id']) => void;
    onExport: (id: ReportData['id']) => void;
    viewMode?: 'list' | 'grid';
}

export default function ReportListItem({
    report,
    onDelete,
    onExport,
    viewMode = 'list',
}: ReportListItemProps) {
    const reportStatus = report.status || 'in_progress';
    const statusInfo = statusConfig[reportStatus];

    if (viewMode === 'grid') {
        return (
            <ReportGridItem
                report={report}
                reportStatus={reportStatus}
                statusInfo={statusInfo}
                onExport={() => onExport(report.id)}
                onDelete={() => onDelete(report.id)}
            />
        );
    }

    return (
        <ReportTableItem
            report={report}
            reportStatus={reportStatus}
            statusInfo={statusInfo}
            onExport={() => onExport(report.id)}
            onDelete={() => onDelete(report.id)}
        />
    );
}
